import { render, staticRenderFns } from "./SingleDocumentModal.vue?vue&type=template&id=0672d267"
import script from "./SingleDocumentModal.vue?vue&type=script&lang=js"
export * from "./SingleDocumentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports